import { Divider, Stack } from '@mantine/core';
import { useEffect, useState } from 'react';
import {
  TriggerDatasetType,
  TriggerInputDataset,
} from '@/hooks/api/datasets/trigger/useTriggerManualRun.ts';
import UploadSingleFile from '../UploadSingleFile.tsx';
import PreviouslyUploadedFiles from '../PreviouslyUploadedFiles/PreviouslyUploadedFiles.tsx';
import { ManualTriggerInput } from '@/types/automationSteps.ts';
import { RelativeFile } from '@/types/common.ts';
import CustomLoadingOverlay from '@/components/CustomLoadingOverlay.tsx';
import ManualTriggerInputHeader from './ManualTriggerInputHeader.tsx';

type props = {
  automationId: string;
  trigger: ManualTriggerInput;
  triggerDataset: TriggerInputDataset;
  setTriggerDataset: (d: TriggerInputDataset) => void;
  isLoading: boolean;
};

const HEADER_SPACING = '4px';

const FileDatasetInput = ({
  automationId,
  trigger,
  triggerDataset,
  setTriggerDataset,
  isLoading,
}: props) => {
  const [uploadNewFiles, setUploadNewFiles] = useState(true);

  useEffect(() => {
    setUploadNewFiles(triggerDataset.type !== TriggerDatasetType.Existing);
  }, [triggerDataset.type]);

  const file =
    'file' in triggerDataset && triggerDataset.file
      ? { file: triggerDataset.file, path: triggerDataset.file.name }
      : undefined;

  const setFile = (f?: RelativeFile) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      file: f?.file,
      type: TriggerDatasetType.File,
    });
  };

  const selectedExistingDatasetId =
    'dataset_id' in triggerDataset ? triggerDataset.dataset_id : undefined;
  const setSelectedExistingDatasetId = (id: string) => {
    setTriggerDataset({
      trigger_id: triggerDataset.trigger_id,
      dataset_id: id,
      type: TriggerDatasetType.Existing,
    });
  };

  return (
    <>
      <Divider style={{ color: '#ececec', borderTopWidth: '0.5px' }} />
      <Stack gap={0}>
        <CustomLoadingOverlay visible={isLoading} />

        <ManualTriggerInputHeader
          trigger={trigger}
          actionLabel={uploadNewFiles ? 'or use previously uploaded file' : 'or upload new file'}
          onActionClick={() => setUploadNewFiles(!uploadNewFiles)}
        />
        <Stack gap={0} mt={HEADER_SPACING}>
          {uploadNewFiles && <UploadSingleFile file={file} setFile={setFile} />}
          {!uploadNewFiles && (
            <PreviouslyUploadedFiles
              automationId={automationId}
              manualTrigger={trigger}
              selectedExistingDatasetId={selectedExistingDatasetId}
              setSelectedExistingDatasetId={setSelectedExistingDatasetId}
            />
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default FileDatasetInput;
